import React, { MouseEventHandler } from "react";
import "./AnswerCard.css";

const AnswerCard = ({
  title,
  selectable,
  selected,
  correct,
  incorrect,
  onlyOneAnswerIsCorrect,
  onClick,
}: {
  title: React.ReactNode;
  selectable: boolean;
  selected: boolean;
  correct: boolean;
  incorrect: boolean;
  onlyOneAnswerIsCorrect: boolean;
  onClick: MouseEventHandler;
}) => {
  let icon = correct ? "bi-check-circle-fill" : "bi-x-circle-fill";

  return (
    <div
      className={
        "answer-button prevent-select" +
        (selectable ? " selectable" : "") +
        (selected ? " selected" : "") +
        (correct ? " correct" : "") +
        (incorrect ? " incorrect" : "")
      }
      id="answer-button"
    >
      <div
        className="inner-container"
        onClick={selectable ? onClick : () => null}
      >
        <div className="left-side">
          <div className="radio">
            <div
              className={
                "radio-inner " + (onlyOneAnswerIsCorrect ? "round" : "square")
              }
            ></div>
          </div>
        </div>
        <div className="main">{title}</div>
      </div>
      <div className="right-side">
        <i className={"bi " + icon + " me-0"}></i>
      </div>
    </div>
  );
};

export default AnswerCard;
